import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, siteAddedAction } from '../../reducers/actions';
import { SiteService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.ADD_SITE),
    switchMap(action =>
      SiteService.create(action.site, store).pipe(
        map(data => siteAddedAction(data)),
        catchError(retryAuthentication(action$, 'epics/sites/siteAdd'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/sites/siteAdd.js